// Pantallas de la consulta de lotes: son HTML/JS nativos, no componentes
// React. App Platform (DigitalOcean) redirige cualquier .html a la ruta sin
// extensión y responde esas rutas con el index.html de React, así que las
// páginas se publican como plantillas .txt y se montan desde acá, reemplazando
// todo el documento antes de que React renderice.
const PLANTILLAS = {
  '/consulta-lotes': '/consulta-lotes/paginas/consulta.txt',
  '/consulta-lotes/admin-busquedas': '/consulta-lotes/paginas/historial.txt',
};

export function plantillaConsultaLotes(pathname) {
  return PLANTILLAS[pathname.replace(/\/+$/, '')] || null;
}

const copiarAtributos = (destino, origen) => {
  [...destino.attributes].forEach(({ name }) => destino.removeAttribute(name));
  [...origen.attributes].forEach(({ name, value }) => destino.setAttribute(name, value));
};

export async function montarPaginaConsultaLotes(urlPlantilla) {
  const respuesta = await fetch(urlPlantilla, { cache: 'no-cache' });
  if (!respuesta.ok) throw new Error(`No se pudo cargar ${urlPlantilla}`);
  const pagina = new DOMParser().parseFromString(await respuesta.text(), 'text/html');

  // Los <script> insertados como HTML no se ejecutan: se recrean al final.
  const scripts = [...pagina.querySelectorAll('script')];
  scripts.forEach((script) => script.remove());

  copiarAtributos(document.documentElement, pagina.documentElement);
  copiarAtributos(document.body, pagina.body);
  // Se descartan los estilos y scripts de la app React (AdminLTE, bundle).
  document.head.replaceChildren(...[...pagina.head.childNodes].map((nodo) => document.importNode(nodo, true)));
  document.body.replaceChildren(...[...pagina.body.childNodes].map((nodo) => document.importNode(nodo, true)));

  // async = false conserva el orden: config.js antes que sesion.js.
  scripts.forEach((original) => {
    const script = document.createElement('script');
    [...original.attributes].forEach(({ name, value }) => script.setAttribute(name, value));
    script.async = false;
    document.body.appendChild(script);
  });
}
